<script>
	import { replace } from 'svelte-spa-router';
	import { devices } from 'src/stores/lists/devices';
	import { setSidePanelState } from './Sidepanel/sidepanel-helpers';

	export let type_id;

	const device = $devices[type_id];

	replace(`/home/room/${device.room_id}/devices`);

	setSidePanelState({ type: 'device', id: device.id, open: true });
</script>
